import revive_payload_client_4sVQNw7RlN from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/var/www/marketplace-dev.ingeniuscloud.net/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_Ug908EZNww from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_PSbK9A48ZQ from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import plugin_TzdokXk5of from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-permissions/dist/runtime/plugin.mjs";
import plugin_vfCt6Q18Tc from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-auth-sanctum/dist/runtime/plugin.js";
import anchorscroll_plugin_PcZY5oWLsO from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-anchorscroll/dist/runtime/anchorscroll-plugin.js";
import plugin_sb2LSEEy8f from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/nuxt-quasar-ui/dist/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/var/www/marketplace-dev.ingeniuscloud.net/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import chartjs_1wC9lAM0Tp from "/var/www/marketplace-dev.ingeniuscloud.net/plugins/chartjs.ts";
import components_m1q6StQDkO from "/var/www/marketplace-dev.ingeniuscloud.net/plugins/components.ts";
import consent_client_xTMARhDQ7q from "/var/www/marketplace-dev.ingeniuscloud.net/plugins/consent.client.ts";
import mitt_client_JdecFmZkyR from "/var/www/marketplace-dev.ingeniuscloud.net/plugins/mitt.client.js";
import partner_theme_client_vSO7Jw3hhF from "/var/www/marketplace-dev.ingeniuscloud.net/plugins/partner-theme.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_Ug908EZNww,
  plugin_PSbK9A48ZQ,
  plugin_TzdokXk5of,
  plugin_vfCt6Q18Tc,
  anchorscroll_plugin_PcZY5oWLsO,
  plugin_sb2LSEEy8f,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  chartjs_1wC9lAM0Tp,
  components_m1q6StQDkO,
  consent_client_xTMARhDQ7q,
  mitt_client_JdecFmZkyR,
  partner_theme_client_vSO7Jw3hhF
]